var _g, _rect, _g2, _rect2, _g3, _rect3, _g4, _rect4, _g5, _rect5, _g6, _rect6, _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _rect7, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollectivePullUps(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 153,
    viewBox: "0 0 277 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11322_9783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 3.93066,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 81 3.93066)",
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.613 84.1127L107.727 81.7928L106.43 57.0575L117.185 56.4939L118.481 81.2291L121.82 83.211",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.754 44.1517L106.543 59.208L117.297 58.6444L116.508 43.5881",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.905 44.0385L108.694 59.0947L115.147 58.7566L114.358 43.7003",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.9668 22.0181L97.2612 32.8505C97.6619 36.2038 99.3955 39.2547 102.071 41.3153V41.3153C104.448 43.1456 107.401 44.0654 110.396 43.9084L111.866 43.8313C114.862 43.6743 117.702 42.4509 119.875 40.3823V40.3823C122.32 38.0533 123.725 34.8379 123.773 31.4611L123.928 20.5527",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 110.512,
    cy: 32.0403,
    r: 6.46154,
    transform: "rotate(-3 110.512 32.0403)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4395 22.4131L131.457 20.1586",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.4395 22.4131L92.2157 94.4681",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.457 20.1582L135.233 92.2132",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.412 11.0693L109.638 15.3711",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.374 13.3325L109.413 11.0689L111.676 13.1071",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 79.949,
    y: 2.98437,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 79.949 2.98437)",
    stroke: "#FBEFD1",
    strokeWidth: 2
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11322_9783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.9062,
    y: 68,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 93.9062 68)",
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.572 150.462L110.945 148.539L112.673 123.83L123.416 124.581L121.688 149.29L124.761 151.664",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.574 110.938L112.522 125.979L123.265 126.73L124.317 111.69",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.723 111.089L114.671 126.129L121.117 126.58L122.168 111.539",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.557 87.7766L106.522 98.686C106.511 102.063 107.86 105.303 110.264 107.674V107.674C112.4 109.78 115.219 111.053 118.211 111.262L119.68 111.365C122.672 111.574 125.641 110.706 128.049 108.918V108.918C130.76 106.904 132.546 103.884 133.006 100.538L134.489 89.7298",
    stroke: "#24284E",
    strokeWidth: 6.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 119.772,
    cy: 99.4961,
    r: 6.46154,
    transform: "rotate(4 119.772 99.4961)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0371 87.251L142.009 90.2559",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0371 87.251L94.0039 159.229",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.009 90.2559L136.976 162.234",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.237 78.5469L120.937 82.8441",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.938 80.5461L121.236 78.5477L123.235 80.8466",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 92.9784,
    y: 66.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 92.9784 66.9327)",
    stroke: "#FBEFD1",
    strokeWidth: 2
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_11322_9783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.681,
    y: 66,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 150.681 66)",
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.435 137.327L160.434 135.884L163.389 114.86L172.53 116.145L169.575 137.169L172.06 139.382",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.93 103.89L163.132 116.688L172.273 117.972L174.071 105.175",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.759 104.147L164.96 116.944L170.445 117.715L172.243 104.918",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.316 83.6663L159.633 92.9923C159.422 95.8793 160.382 98.7298 162.296 100.901V100.901C163.996 102.83 166.33 104.087 168.877 104.445L170.126 104.62C172.672 104.978 175.262 104.413 177.428 103.028V103.028C179.867 101.468 181.575 98.9927 182.168 96.1594L184.082 87.0065",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.914,
    cy: 94.478,
    r: 5.53846,
    transform: "rotate(8 170.914 94.478)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.917 82.7676L190.481 87.9063",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.917 82.7676L145.31 144.012",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.48 87.9062L181.873 149.151",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.42 76.6523L172.906 80.3087",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.334 78.2237L173.419 76.6524L174.99 78.7376",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 149.83,
    y: 64.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 149.83 64.8706)",
    stroke: "#FBEFD1",
    strokeWidth: 2
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_11322_9783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.5088,
    y: 37,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(9 59.5088 37)",
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0169 108.433L68.0409 107.043L71.3621 86.0738L80.4792 87.5178L77.158 108.487L79.6043 110.744",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0958 75.1335L71.0742 87.8975L80.1913 89.3415L82.213 76.5775",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9191 75.4226L72.8975 88.1865L78.3677 89.0529L80.3893 76.289",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8342 54.8326L67.989 64.1452C67.7273 67.0281 68.6371 69.8949 70.5132 72.0994V72.0994C72.1795 74.0574 74.4913 75.3548 77.0308 75.757L78.2772 75.9544C80.8167 76.3567 83.4163 75.8372 85.6062 74.4899V74.4899C88.0716 72.973 89.8228 70.5277 90.4648 67.705L92.5387 58.587",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 79.2425,
    cy: 65.8259,
    r: 5.53846,
    transform: "rotate(9 79.2425 65.8259)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4521 53.8213L98.9206 59.5973",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4521 53.8213L52.7773 114.906",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9209 59.5977L89.246 120.682",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0576 48.0479L81.48 51.6947",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9456 49.5822L82.0578 48.0476L83.5924 50.1598",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 58.6775,
    y: 35.8559,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 58.6775 35.8559)",
    stroke: "#FBEFD1",
    strokeWidth: 2
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_11322_9783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 28.8828,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-9 182 28.8828)",
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.037 89.5985L209.279 87.5299L206.235 68.308L214.592 66.9843L217.637 86.2062L220.409 87.4806",
    stroke: "#24284E",
    strokeWidth: 5.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.647 58.2792L206.5 69.9795L214.857 68.6558L213.004 56.9555",
    stroke: "#24284E",
    strokeWidth: 5.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.318 58.0145L208.171 69.7148L213.185 68.9206L211.332 57.2203",
    stroke: "#24284E",
    strokeWidth: 5.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.181 41.7874L197.082 50.1456C197.671 52.733 199.276 54.9747 201.536 56.3651V56.3651C203.543 57.6001 205.926 58.0763 208.254 57.7076L209.397 57.5266C211.725 57.1579 213.844 55.9687 215.371 54.1738V54.1738C217.091 52.153 217.925 49.5251 217.685 46.8825L216.91 38.3459",
    stroke: "#24284E",
    strokeWidth: 5.07692,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 207.369,
    cy: 48.4243,
    r: 5.07692,
    transform: "rotate(-9 207.369 48.4243)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.331 42.7139L222.761 37.4192",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.331 42.7139L198.2 98.7082",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.761 37.4189L231.629 93.4133",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.788 32.127L205.318 35.4699",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.381 34.0631L204.788 32.1269L206.724 33.5336",
    stroke: "#24284E",
    strokeWidth: 1.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 180.856,
    y: 28.0516,
    width: 46,
    height: 46,
    rx: 23,
    transform: "rotate(-9 180.856 28.0516)",
    stroke: "#FBEFD1",
    strokeWidth: 2
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5_11322_9783)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.184,
    y: 26,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(5 130.184 26)",
    fill: "#F7BB47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.662 96.8749L143.581 95.2771L145.432 74.1271L154.627 74.9316L152.777 96.0816L155.375 98.1621",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.397 63.0929L145.271 75.9668L154.466 76.7713L155.592 63.8974",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.237 63.2531L147.11 76.127L152.628 76.6097L153.754 63.7358",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73 43.1384L140.537 52.4873C140.477 55.3814 141.585 58.1778 143.61 60.246V60.246C145.409 62.0831 147.805 63.216 150.367 63.4401L151.624 63.5501C154.185 63.7742 156.742 63.0746 158.833 61.5779V61.5779C161.186 59.8927 162.763 57.3311 163.206 54.4706L164.639 45.2301",
    stroke: "#24284E",
    strokeWidth: 5.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 151.879,
    cy: 53.38,
    r: 5.53846,
    transform: "rotate(5 151.879 53.38)",
    fill: "#24284E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.293 42.5752L171.076 45.7933",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.293 42.5752L128.903 104.186",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.076 45.793L165.686 107.404",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.448 35.4482L153.126 39.1265",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.448 37.1262L153.449 35.448L155.127 37.448",
    stroke: "#24284E",
    strokeWidth: 1.84615,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 129.275,
    y: 24.9166,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 129.275 24.9166)",
    stroke: "#FBEFD1",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61 95C61 93.8954 61.8954 93 63 93H83.2654C84.2607 93 85.1046 93.7319 85.2453 94.7172L88.7547 119.283C88.8954 120.268 89.7393 121 90.7346 121H191.265C192.261 121 193.105 120.268 193.245 119.283L196.755 94.7172C196.895 93.7319 197.739 93 198.735 93H219C220.105 93 221 93.8954 221 95V121V147C221 148.105 220.105 149 219 149H189H93H63C61.8954 149 61 148.105 61 147V121V95Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 54.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 275.5,
    cy: 57.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 61.5,
    cy: 9.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 247.5,
    cy: 123.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 15.5,
    r: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 33 153)",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M240.5 26.5L262.5 20",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M237 83.5L254.5 87",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19L48.5 26",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20 86L38 82.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11322_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 3.93066,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(-3 81 3.93066)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11322_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 93.9062,
    y: 68,
    width: 56,
    height: 56,
    rx: 28,
    transform: "rotate(4 93.9062 68)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_11322_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 150.681,
    y: 66,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(8 150.681 66)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_11322_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 59.5088,
    y: 37,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(9 59.5088 37)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_11322_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182,
    y: 28.8828,
    width: 44,
    height: 44,
    rx: 22,
    transform: "rotate(-9 182 28.8828)",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5_11322_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.184,
    y: 26,
    width: 48,
    height: 48,
    rx: 24,
    transform: "rotate(5 130.184 26)",
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectivePullUps);
export default __webpack_public_path__ + "static/media/collective-pull-ups.36c9453a4b38a8b33320677e1cbe297f.svg";
export { ForwardRef as ReactComponent };